import { Dialog } from "./dialog";
import { Button } from "../buttons/button";

interface DeleteTeamDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  teamName?: string;
}

export const DeleteTeamDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  teamName,
}: DeleteTeamDialogProps) => {
  if (!isOpen) return null;

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div className="bg-red-50 p-6 rounded-lg border-2 border-red-200 max-w-md w-full m-4">
        <div className="text-center">
          <p className="text-red-700 mb-4">
            Are you sure you want to delete "{teamName}"?
          </p>
          <div className="bg-red-100 p-4 rounded-lg mb-6 border border-red-200">
            <ul className="text-red-700 text-sm leading-relaxed text-left">
              <li>- This action cannot be undone</li>
              <li>- Pokemons won't be deleted</li>
            </ul>
          </div>
          <div className="flex gap-4 items-center justify-center w-full">
            <Button
              variant="black"
              onClick={onClose}
              disabled={isLoading ?? false}
              className="flex-1"
            >
              CANCEL
            </Button>
            <Button
              variant="red"
              onClick={onConfirm}
              disabled={isLoading ?? false}
              className="flex-1"
            >
              {isLoading ? "DELETING..." : "DELETE TEAM"}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
